/* eslint-disable no-nested-ternary */
import React, { createRef, useState, forwardRef, useImperativeHandle } from 'react';

import axios from 'axios';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import Preloader from '../Preloader/Preloader';

import LibraryAssets from './LibraryAssets';
import { SnippetTypeConst } from './SnippetTypeConst';

import CreateAssetRequest from '../../middleware/Asset/createAssetRequest';
import CreateDocumentContentSnippetRequest from '../../middleware/ContentSnippet/createDocumentContentSnippetRequest';
import UpdateContentDocumentSnippetReq from '../../middleware/ContentSnippet/updateContentDocumentSnippetReq';

const EditableDocumentSnippet = forwardRef((props, ref) => {
  const {
    containerId,
    onCancel,
    onUpdate,
    onCreate,
    onAddFile = () => {},
    isSnippetInForm,
    onEditQuesSuccess,
    snippet,
    handleCloseEditMedia = () => {},
  } = props;

  const [loader, setLoader] = useState(false);
  const [file, setFile] = useState(null);
  const [createAsset, setCreateAsset] = useState(false);
  const [createSnippet, setCreateSnippet] = useState(false);
  const [asset, setAsset] = useState(null);
  const [openLib, setOpenLib] = useState(false);
  const [assetFromLib, setAssetFromLib] = useState(false);
  const dropzoneRef = createRef();

  const [preview, setPreview] = useState(null);

  //   if (dropzoneRef.current) {
  //     dropzoneRef.current.open();
  //   }
  // };

  const openLibrary = () => {
    setOpenLib(true);
  };

  const handleFileDrop = (files) => {
    setFile(files[0]);
    setPreview(URL.createObjectURL(files[0]));
  };

  const handleSaveButton = () => {
    if (assetFromLib) setCreateSnippet(true);
    else setCreateAsset(true);
  };

  const handleAssetError = () => {
    setCreateAsset(false);
  };

  const handleAssetResponse = (data) => {
    const {
      asset: {
        createAsset: { signedUrl, asset },
      },
    } = data;
    setCreateAsset(false);
    setLoader(true);
    Object.defineProperty(file, 'name', {
      writable: true,
      value: asset.s3Key,
    });

    axios
      .put(signedUrl, file, { headers: {} })
      .then(() => {
        setAsset(asset);
        setLoader(false);
        setCreateSnippet(true);
      })
      .catch(() => {
        setLoader(false);
      });
  };

  const handleSnippetError = () => {
    setCreateSnippet(false);
  };

  const handleSnippetResponse = (id, sort) => {
    onAddFile(preview, 'document');
    // onCreate(id, sort, SnippetTypeConst.DOCUMENT, containerId, {
    //   asset,
    //   assetId: asset.assetId,
    // });
    if (snippet) {
      onUpdate(id, sort, SnippetTypeConst.DOCUMENT, containerId, {
        asset,
        assetId: asset.assetId,
      });
    } else {
      onCreate(id, sort, SnippetTypeConst.DOCUMENT, containerId, {
        asset,
        assetId: asset.assetId,
      });
    }
    setCreateSnippet(false);
    onEditQuesSuccess();
    handleCloseEditMedia();
  };

  useImperativeHandle(ref, () => ({
    handleSaveButton() {
      setCreateAsset(true);
    },
  }));

  const handleSelectAsset = (ass) => {
    setAsset(ass);
    setAssetFromLib(true);
  };

  return (
    <>
      {file ? (
        <div>
          <p style={{ textAlign: 'center' }}>{file.path} is uploaded</p>
        </div>
      ) : !openLib ? (
        <div>
          <Dropzone ref={dropzoneRef} accept=".pdf,.doc,.docx, .xls, .xlsx" noClick noKeyboard onDropAccepted={handleFileDrop}>
            {({ getRootProps, getInputProps, isDragActive }) => (
              <div className="container">
                <div {...getRootProps({ className: 'dropzone' })}>
                  <input {...getInputProps()} />
                  <p>{isDragActive ? 'Drop here' : 'Drop document here or click to upload'}</p>
                  <p>
                    (<strong>Maximum</strong> 1 file)
                  </p>
                </div>
              </div>
            )}
          </Dropzone>
          <div className="mt-3 text-center">
            <button className="button--green" type="button" onClick={openLibrary}>
              Choose from library
            </button>
          </div>
        </div>
      ) : (
        <LibraryAssets goBack={() => setOpenLib(false)} isClicked={handleSelectAsset} type="DOCUMENT" />
      )}

      {!isSnippetInForm && (
        <div className="text-right">
          <button className="button--black mt-4 mr-3" type="button" onClick={onCancel}>
            Cancel
          </button>
          <button className="mt-4 button--blue" type="submit" onClick={handleSaveButton}>
            Save
          </button>
        </div>
      )}
      {createAsset && (
        <CreateAssetRequest
          contentType={file.type}
          fileName={file.name}
          fileSizeInBytes={file.size}
          type="DOCUMENT"
          onError={handleAssetError}
          onSuccessResult={handleAssetResponse}
        />
      )}
      {createSnippet && !snippet && (
        <CreateDocumentContentSnippetRequest
          assetId={asset.assetId}
          containerId={Number(containerId)}
          isVisible
          onError={handleSnippetError}
          onSuccessResult={handleSnippetResponse}
        />
      )}
      {createSnippet && snippet && (
        <UpdateContentDocumentSnippetReq
          assetId={asset.assetId}
          duration={0}
          snippetId={snippet.id}
          startAt={0}
          onError={handleSnippetError}
          onSuccessResult={handleSnippetResponse}
        />
      )}
      {loader && <Preloader text="Uploading document. Please wait!" />}
    </>
  );
});

EditableDocumentSnippet.propTypes = {
  containerId: PropTypes.number.isRequired,
  handleCloseEditMedia: PropTypes.func,
  isSnippetInForm: PropTypes.bool,
  onAddFile: PropTypes.func,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  onEditQuesSuccess: PropTypes.func,
  onUpdate: PropTypes.func,
  snippet: PropTypes.instanceOf(Object),
};

EditableDocumentSnippet.defaultProps = {
  handleCloseEditMedia: () => {},
  isSnippetInForm: false,
  onAddFile: () => {},
  onCancel: () => {},
  onCreate: () => {},
  onEditQuesSuccess: () => {},
  onUpdate: () => {},
  snippet: null,
};

// export default forwardRef(EditableAudioSnippet);
export default EditableDocumentSnippet;
